export enum EnquiryFormsRoles {
  VIEWER = 'roles.enquiryFormsViewer',
  MANAGER = 'roles.enquiryFormsManager',
}
